<template>
  <div>
    The along-track tolerance <katex-element expression="\Delta L" /> is defined
    as follows :
    <br />
    <br />
    <v-img
      contain
      :src="
        require('../../../assets/images/description-station-keeping-parametric.png')
      "
      aspect-ratio="2.5"
    />
    <br />
    <br />
    <p>
      This value will be used to compute an associated semi-major axis margin
      <katex-element expression="\Delta a" />, given by:
    </p>
    <div style="font-size: large">
      <katex-element
        expression="\Delta a = 2\sqrt{ \Delta L \cdot \epsilon  / 3n}"
      />
    </div>
    <br />
    <p>
      Where <katex-element expression="n" /> is the orbit mean motion and
      <katex-element expression="\epsilon" /> is the orbit decay rate, function
      of the ballistic coefficient, the atmospheric density at the orbit
      altitude and the orbit inclination.
    </p>
    <p>
      The station-keeping simulation will then compute compute the manoeuvres
      that allow the spacecraft to respect a semi-major axis tolerance of
      <katex-element expression="2\Delta a" /> (top margin of
      <katex-element expression="\Delta a" />, bottom margin of
      <katex-element expression="\Delta a" />).
    </p>
    <p>
      The equation that relates <katex-element expression="\Delta L" /> to
      <katex-element expression="\Delta a" /> is an analytical approximation
      based on impulsive manoeuvres. For low-thrust manoeuvres, an iterative
      process is made to take into account the along-track drift during the
      manoeuvre itself. The algorithm is initialized with an initial value of
      <katex-element expression="\Delta a" /> given by the equation above.At
      each iteration, the manoeuvre is evaluated and the spacecraft position at
      its end compared to the box defined by
      <katex-element expression="\Delta L" />. If the box is not respected,
      <katex-element expression="\Delta a" /> is multiplied by a scaling factor
      currently set to 0.9, and the manoeuvre is re-evaluated. This process
      continues until the box is respected or the maximum of iterations is
      reached (currently 100).
    </p>
    <p>
      The simulation guarantees only a the respect of the semi-major axis margin
      <katex-element expression="\Delta a" />, hence the actual value of the
      along-track margin achieved might be greater than the requested tolerance
      <katex-element expression="\Delta L" />.
    </p>
    <h3>References</h3>
    <p>
      Chao, Chia-Chun George, Applied orbit perturbation and maintenance, 2005,
      American Institute of Aeronautics and Astronautics, Inc.
    </p>
  </div>
</template>

<script>
export default {
  name: 'tooltipAlongTrackTolerance'
}
</script>
